module.exports = __webpack_public_path__ + "img/ZWF_Gilson_Sara.c396aa19.jpg";